<template>
  <section class="section">
    <div class="container">
      <div class="columns is-multiline">
        <div class="column is-4">
          <b-button :disabled="disabledbool" style="width: 100%" class="is-primary" @click="importModel">
            {{ $translate('catalog_view') }}
          </b-button>
        </div>
        <div class="column is-4 is-offset-1">
          <b-button :disabled="disabledbool" style="width: 100%" class="is-primary" @click="suggDuna">
            {{ $translate('sugg_duna') }}
          </b-button>
        </div>

        <b-tabs position class="blocks fulllength" horizontal>
          <b-tab-item :label="$translate('materials') | capitalize">
            <div class="columns">
              <div class="column is-4">
                <imageModel :mod.sync="mod" :order.sync="order" />
              </div>
              <div class="column is-8">
                <b-field
                  :type="{ 'is-danger': errors.has(`dime_${side}`) }"
                  :message="errors.first(`dime_${side}`)"
                  :label="$translate('dime') | capitalize"
                >
                  <b-field grouped>
                    <b-select
                      v-model="mod.dime"
                      v-validate="'required'"
                      :name="`dime_${side}`"
                      :disabled="disabledbool || !mod.image"
                      @input="onDimeChange"
                    >
                      <option v-for="optio in $availableDime" :key="optio" :value="optio">
                        {{ $translate(optio) | capitalize }}
                      </option>
                    </b-select>
                    <b-input
                      v-if="mod.dime === 'dunadime'"
                      v-model="mod.dime_description"
                      :placeholder="$translate('placeholder_description')"
                      :disabled="disabledbool || !mod.image"
                      :controls="false"
                      expanded
                    />
                  </b-field>
                </b-field>
                <b-field
                  v-if="mod.dime === 'dunadime' || mod.dime === 'customerdime'"
                  :type="{ 'is-danger': errors.has(`dime_fondo_${side}`) }"
                  :message="errors.first(`dime_fondo_${side}`)"
                  :label="$translate('fondo') | capitalize"
                >
                  <b-select
                    v-model="mod.dime_fondo"
                    v-validate="'required'"
                    :name="`dime_fondo_${side}`"
                    :disabled="disabledbool || !mod.image"
                    @input="onDimeFondoChange"
                  >
                    <option value="flat_plantar">{{ $translate('flat_plantar') | capitalize }}</option>
                    <option value="shaped_plantar">{{ $translate('shaped_plantar') | capitalize }}</option>
                  </b-select>
                </b-field>
                <b-field
                  v-if="(mod.dime === 'dunadime' || mod.dime === 'customerdime') && mod.dime_fondo === 'shaped_plantar'"
                  :type="{ 'is-danger': errors.has(`cambratura_fondo_${side}`) }"
                  :message="errors.first(`cambratura_fondo_${side}`)"
                  :label="$translate('cambratura_fondo') | capitalize"
                >
                  <b-input
                    v-model="mod.cambratura_fondo"
                    v-validate="'required|between:0,999'"
                    :name="`cambratura_fondo_${side}`"
                    type="number"
                    :placeholder="$translate('placeholder_measure_mm')"
                    :disabled="disabledbool || !mod.image"
                    :use-html5-validation="false"
                  />
                </b-field>
                <hr />
                <insole
                  ref="insole"
                  :mod.sync="mod"
                  :orderbool="true"
                  :name-suffix="`_${side}`"
                  :available-insole-base="availableInsoleBase"
                  :available-insole-cover="availableInsoleCover"
                  :available-insole-fill="availableInsoleFill"
                  :disabledbool="disabledbool || !mod.image"
                  :hide-cover="isNoCover"
                  @onChangeMat="onChangeMat"
                />
              </div>
            </div>
          </b-tab-item>
          <b-tab-item :label="$translate('prod_details') | capitalize">
            <div class="columns">
              <div class="column is-4">
                <imageModel :mod.sync="mod" :order.sync="order" />
              </div>
              <div class="column is-8">
                <inserts
                  ref="inserts"
                  :mod.sync="mod"
                  :orderbool="true"
                  :name-suffix="`_${side}`"
                  :single-side="side"
                  :available-inserts="availableInserts"
                  :disabledbool="disabledbool || !mod.image"
                />
              </div>
            </div>
          </b-tab-item>
        </b-tabs>

        <b-modal
          :active.sync="isComponentModalActive"
          has-modal-card
          trap-focus
          aria-role="dialog"
          aria-modal
          custom-class="insole-catalog-modal"
        >
          <div class="modal-card">
            <header class="modal-card-head">
              <p class="modal-card-title">{{ $translate('catalog_view') }}</p>
              <b-input v-model="filterModel" />
            </header>
            <section class="modal-card-body">
              <div class="columns is-multiline is-mobile">
                <div v-for="model in filteredModels" :key="model.id" class="column is-half">
                  <div class="card">
                    <div class="card-image">
                      <figure class="image is-4by3">
                        <img :src="model.image" alt="Placeholder image" />
                      </figure>
                    </div>
                    <div class="card-content" style="height: 96px">
                      <div class="content has-text-centered">
                        {{ model.name }}
                      </div>
                    </div>
                    <footer class="card-footer">
                      <a
                        class="card-footer-item"
                        @click="
                          tempmodel = model
                          importBasicData()
                        "
                        >{{ $translate('import') | capitalize }}</a
                      >
                    </footer>
                  </div>
                </div>
              </div>
            </section>
            <footer class="modal-card-foot">
              <button class="button" type="button" @click="isComponentModalActive = false">
                {{ $translate('close') | capitalize }}
              </button>
            </footer>
          </div>
        </b-modal>
      </div>
    </div>
  </section>
</template>

<script>
import insole from '../../Mod/components/insole.vue'
import { compareModelPosition } from '@/helpers/mixins/modelTools'
import inserts from '../../Mod/components/inserts.vue'
import imageModel from './ImageModel'

export default {
  name: 'OrderModelInsole',
  components: {
    insole,
    inserts,
    imageModel,
  },
  props: {
    side: {
      type: String,
      default: 'sx',
    },
    mod: {
      type: Object,
      default: () => {
        return {}
      },
    },
    order: {
      type: Object,
      default: () => {
        return {}
      },
    },
    config: {
      type: Object,
      required: true,
      default: () => {
        return {}
      },
    },
    catalogModel: {
      type: Object,
      default: () => {
        return {}
      },
    },
    availableInsoleBase: {
      type: Array,
      default: () => {
        return []
      },
    },
    availableInsoleCover: {
      type: Array,
      default: () => {
        return []
      },
    },
    availableInsoleFill: {
      type: Array,
      default: () => {
        return []
      },
    },
    availableInserts: {
      type: Array,
      default: () => {
        return []
      },
    },
    disabledbool: Boolean,
    isSaveDisabled: Boolean,
    isSimplified: Boolean,
  },
  inject: ['$validator'],
  mounted() {
    this.updateAfterload()
  },
  data() {
    return {
      models: [],
      isComponentModalActive: false,
      tempmodel: {},
      filterModel: '',
    }
  },
  computed: {
    filteredModels() {
      return this.models
        .filter(model => model.name.toLowerCase().includes(this.filterModel.toLowerCase()))
        .sort(compareModelPosition)
    },
    isNoCover() {
      return (
        (this.order.deliverySelected === 'finishedplantar' || this.order.deliverySelected === 'border_cropped') &&
        this.order.deliverySelectedSub === 'nocover'
      )
    },
  },
  methods: {
    refreshCatalog() {
      if (this.catalogModel !== undefined) {
        this.$db
          .collection(this.config.models)
          .where('draft', '==', false)
          .get()
          .then(docs => {
            this.models = []
            docs.forEach(doc => {
              let mode = doc.data()
              mode.id = doc.id
              if (this.catalogModel[mode.id]) {
                this.models.push(mode)
              }
            })
            this.$forceUpdate()
          })
      }
    },
    async updateAfterload() {
      this.refreshCatalog()
      if (this.mod && this.mod.dime_description === undefined) {
        this.$set(this.mod, 'dime_description', null)
      }
      if (this.mod && this.mod.dime_fondo === undefined) {
        this.$set(this.mod, 'dime_fondo', null)
      }
      if (this.mod && this.mod.cambratura_fondo === undefined) {
        this.$set(this.mod, 'cambratura_fondo', null)
      }
    },
    onDimeChange() {
      if (this.mod.dime !== 'dunadime') {
        this.$set(this.mod, 'dime_description', null)
      }
      if (this.mod.dime !== 'dunadime' && this.mod.dime !== 'customerdime') {
        this.$set(this.mod, 'dime_fondo', null)
        this.$set(this.mod, 'cambratura_fondo', null)
      }
    },
    onDimeFondoChange() {
      if (this.mod.dime_fondo !== 'shaped_plantar') {
        this.$set(this.mod, 'cambratura_fondo', null)
      }
    },
    importModel() {
      this.isComponentModalActive = true
    },
    importBasicData() {
      this.$buefy.notification.open({
        duration: 3000,
        message: this.$translate('warning_import_model'),
        type: 'is-warning',
      })
      const cloneDeep = require('clone-deep')
      let tempMod = cloneDeep(this.mod)
      tempMod.image = this.tempmodel.image
      tempMod.name = this.tempmodel.name
      tempMod.id = this.tempmodel.id
      tempMod.sizes = this.tempmodel.sizes != null ? this.tempmodel.sizes : null
      tempMod.dime = null
      tempMod.dime_description = null
      tempMod.dime_fondo = null
      tempMod.cambratura_fondo = null
      tempMod.description = this.tempmodel.description != null ? this.tempmodel.description : null
      tempMod.catalogchoose = false
      tempMod.custom = false
      this.disabledbool = false
      this.$emit('update:mod', tempMod)
      this.isComponentModalActive = false
    },
    suggDuna() {
      if (this.mod.image) {
        this.$buefy.dialog.confirm({
          title: this.$translate('attention'),
          message: this.$translate('alert_model'),
          cancelText: this.$translate('undo'),
          confirmText: this.$translate('confirm'),
          onConfirm: () => {
            const cloneDeep = require('clone-deep')
            let temp = cloneDeep(this.tempmodel)
            for (let element in temp) {
              if (temp[element] === undefined) {
                temp[element] = null
              }
            }
            if (temp.inserts) {
              const otherSide = this.side === 'sx' ? 'dx' : 'sx'
              const hasFilledSlot = slots =>
                Array.isArray(slots) && slots.some(slot => slot && slot.material != null)
              ;['avampiede', 'mesopiede', 'retropiede', 'piani_inclinati'].forEach(section => {
                const own = temp.inserts[`${section}_${this.side}`]
                const mirror = temp.inserts[`${section}_${otherSide}`]
                if (!hasFilledSlot(own) && hasFilledSlot(mirror)) {
                  temp.inserts[`${section}_${this.side}`] = cloneDeep(mirror)
                }
              })
            }
            this.$emit('update:mod', temp)
            const syncKeys = [
              'insoleBaseMat',
              'insoleBaseVar',
              'insoleCoverMat',
              'insoleCoverVar',
              'insoleFillMat',
              'insoleFillVar',
            ]
            syncKeys.forEach(key => {
              this.$emit('materialChanged', { key, value: temp[key] != null ? temp[key] : null })
            })
            if (temp.thicknesses) {
              Object.keys(temp.thicknesses).forEach(key => {
                this.$set(this.order.footmeasurements, `${key}_${this.side}`, temp.thicknesses[key])
              })
            }
          },
        })
      } else {
        this.$buefy.toast.open(this.$translate('error_sugg'))
      }
    },
    onChangeMat({ key, value }) {
      this.$set(this.mod, key, value)
      this.$emit('materialChanged', { key, value })
    },
    deliveryUpdated() {
      this.$forceUpdate()
    },
    resetTabs() {
      this.$forceUpdate()
    },
  },
}
</script>
<style>
.insole-catalog-modal .modal-card {
  width: 960px;
  max-width: 90vw;
}
</style>
